import { Component } from '@angular/core';

@Component({
  selector: 'app-utility-asset-and-customer-entities',
  standalone: false,
  templateUrl: './utility-asset-and-customer-entities.component.html',
  styleUrl: './utility-asset-and-customer-entities.component.scss'
})
export class UtilityAssetAndCustomerEntitiesComponent {

}
